import { ICampaign } from 'types/campaign';

export const computeFullDiscount = (config: ICampaign | undefined, amount: number) => {
    const res = {
        fullDiscount: 0,
        string: ''
    };
    if (!config) return res;

    const fullConfig = config.full_discount;
    if (!fullConfig) return res;

    if (!config.bigFullSmall) {
        config.bigFullSmall = fullConfig.reverse();
    }

    for (let item of config.bigFullSmall) {
        if (item.full <= amount) {
            return {
                fullDiscount: item.discount,
                string: `满${item.full / 100}减${item.discount / 100}`
            };
        }
    }

    return res;
};
